import { Link } from 'react-router-dom';
import type { CaseItem } from '@/types/content';
import { getPerson } from '@/utils/content';
import HeatBadge from './HeatBadge';

interface CaseCardProps {
  item: CaseItem;
}

export default function CaseCard({ item }: CaseCardProps) {
  const people = item.personIds.map((id) => getPerson(id)).filter(Boolean).slice(0, 4);

  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors flex flex-col">
      <Link to={`/case/${item.id}`} className="block cursor-pointer">
        <div className="relative w-full h-44 md:h-48 overflow-hidden">
          <img
            src={item.cover}
            alt={`${item.title} 事件封面图`}
            title={`${item.title} - 911吃瓜`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-xs font-semibold text-primary-700">
            {item.category}
          </span>
          <span className="absolute top-3 right-3">
            <HeatBadge heat={item.heat} />
          </span>
        </div>
      </Link>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <Link to={`/case/${item.id}`} className="cursor-pointer">
          <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{item.summary}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
          <div className="flex items-center -space-x-2">
            {people.map((person) => (
              <img
                key={person!.id}
                src={person!.avatar}
                alt={`${person!.name} 头像`}
                title={`${person!.name} - ${item.title}`}
                className="w-7 h-7 rounded-full object-cover object-top border-2 border-background-50"
              />
            ))}
            <span className="pl-3 text-xs text-foreground-500 whitespace-nowrap">{item.personIds.length} 位人物</span>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap flex items-center gap-1">
            <i className="ri-eye-line" />
            {item.views}
          </span>
        </div>
      </div>
    </article>
  );
}